import React from 'react';
import { AchievementsModal } from '../../components/habitsDashboard/AchievementsModal';

const AchievementsPage: React.FC = () => {
  return <AchievementsModal isOpen={true} onClose={() => window.history.back()} />;
};

export default AchievementsPage;
